import React from 'react';
import { Route } from 'react-router-dom';
import Home from './modules/home';
import Error404 from './modules/pages/Error404';
import blogRoutes from './modules/blog';
import pageRoutes from './modules/pages';
import authRoutes, { ActivationRoute } from './modules/auth';
import accountRoutes from './modules/account';
import serviceRequestRoutes from './modules/servicerequest';
import providerRoutes from './modules/provider';
import adminRoutes from './modules/admin';
import styleGuideRoutes from './modules/styleguide';
import searchRoutes from './modules/search';
import siteAdminRoutes from './modules/siteadmin';

const defaultRoutes = () => [
  <Route exact path="/" key="home" component={Home} />,
  <Route path="/" key="404" component={Error404} />,
];

// this list is used to generate the sitemap.xml
// it should contain all routes Google can index.
export const publicRoutes = [
  ...pageRoutes(),
  //...authRoutes(),
  ...blogRoutes(),
  ...providerRoutes(),
  //...adminRoutes(),
  ...searchRoutes(),
  ...styleGuideRoutes(),
  //...siteAdminRoutes(),
  ...defaultRoutes(),
];

// These routes cannot be accessed if activation_required is set on the current profile.
const subroutes = [
  ...blogRoutes(),
  ...providerRoutes(),
  ...serviceRequestRoutes(),
  ...adminRoutes(),
  ...accountRoutes(),
  ...searchRoutes(),
  ...styleGuideRoutes(),
  ...siteAdminRoutes(),
  ...defaultRoutes(),
];

const routes = [
  ...pageRoutes(),
  ...authRoutes(),
  ActivationRoute(subroutes),
];

export default routes;
